import { Component, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { FormsService } from 'src/app/applicationModules/eSignature/services/forms.service';
import { LoaderService } from '../../loader/loader.service';
import { MatAccordion, MatExpansionModule, MatExpansionPanel } from '@angular/material/expansion';
import * as jwt_decode from 'jwt-decode';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { AddAIQualificationTemplateComponent } from 'src/app/middleware/common/addAIQualificationTemplate/addAIQualificationTemplate.component';

@Component({
  selector: 'app-qualifyingThresholdRules',
  templateUrl: './qualifyingThresholdRules.component.html',
  styleUrls: ['./qualifyingThresholdRules.component.scss']
})
export class QualifyingThresholdRulesComponent implements OnInit, OnChanges {


  @Input() ThresholdList;
  @Input() transactionID: number = 0;
  @Input() referralID: number = 0;
  @Input() sysPromptList: any[] = [];
  @Input() openAllAccordian;
  @Input() closeAllAccordian;
  @Input() documentsId: number = 0;
  currentUser: any;
  OfficeIDList: any = [];
  myOfficeID: any;


  @Input() VectorDocumentID;
  @Input() pdfURL;
  @Input() pdfTextFromOCR;
  @Input() documentId;
  @Input() ocrTextFileUrl;
  @Output() sendDeletedRule = new EventEmitter();
  @Output() sendNewThresholdList = new EventEmitter();
  @Output() sendsaveUpdateThresholdRules = new EventEmitter();
  @Output() sendPageNumber = new EventEmitter();
  askQAquery: string;
  apiResponseTextArea: any;
  deletedQuery: any = [] = [];
  responseHolder: any = [] = [];
  organizationId: string;
  databaseId: string;  
  @ViewChild(MatAccordion) accordion: MatAccordion;
  @ViewChildren(MatExpansionPanel) expansionPanel: QueryList<MatExpansionPanel>;
  openpanel: number;
  step = 0;
  currentAnswerChooseIndex: any;

  menuModulesList: any;
  CoreShowName: any; 
  rules:any=[]=[];
  rulesCount:any=[]=[];
  TotalThresholdValue:number=0;

 
  constructor(private _dataSharingService: DataSharingService, private formsService: FormsService, private loaderService: LoaderService,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private statusConst: StatusConstant, private toastr: ToastrService,
    private dialog: MatDialog, private formBuilder: FormBuilder) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    this.menuModulesList = JSON.parse(sessionStorage.getItem('menuModules'));
    let SelectedCore = this.menuModulesList.filter((x) => x.mainModuleName == 'Core');
    if (SelectedCore.length > 0) {
      this.CoreShowName = SelectedCore[0].orgModuleName;
    }
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngOnInit(): void {
 
  }

  ngOnChanges(changes: SimpleChanges) {
   this.getThresholdRules();
  }

 getThresholdRules() {
    var ReqModel = {
      coreID: this.transactionID,
      documentID:this.documentsId,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.formsService.getReferralQuestionAnswers(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.ThresholdList=this.responseHolder.data.questions;         
          this.rules=this.ThresholdList;   
          this.rulesCount= this.ThresholdList.filter(x=>x.mandatoryRule==true);          
        } else {
          this.rules=[];
         this.loaderService.hide();
        }
      } else {
        this.rules=[];
        this.loaderService.hide();
      }
    });
  }
 
  selectedType:string="";
  isMandatoryPass:boolean;
  isMandatoryRule:boolean;

    onTypeSelect(type,rule:any) {
      this.selectedType = type;
      
      if(this.selectedType=="PASS"){
        this.isMandatoryPass=true;
      }
      if(this.selectedType=="FAIL"){
        this.isMandatoryPass=false;
      }
      rule.isMandatoryPass=this.isMandatoryPass;
    }

    onMandatoryChange(event: MatCheckboxChange,rule) {
        this.isMandatoryRule = event.checked;
        if(this.isMandatoryRule==true){
          this.selectedType="PASS";
        }
        rule.mandatoryRule=event.checked;
        
     }

   deleteRule(rule, removeIndex) {
    this.deletedQuery = [];
    var message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.deletedQuery.push(rule);
        if (removeIndex !== -1) this.ThresholdList.splice(removeIndex, 1);
        this.sendDeletedRule.emit(this.deletedQuery);
       // this.sendNewThresholdList.emit(this.ThresholdList);
        this.rules=this.ThresholdList;   
        this.rulesCount= this.ThresholdList.filter(x=>x.mandatoryRule==true); 
      }
    });
  }

    editRule(rule, removeIndex){
       const dialogRef = this.dialog.open(AddAIQualificationTemplateComponent, {
            data: {
              records:rule,
              questionID:rule.quetionID,
              coreId:this.transactionID,
              documentId:this.documentId,
              referralID:this.referralID
            },
            width: '45vw',
            height: 'auto',
            panelClass: 'custom-dialog-container'
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result != null && result != undefined) {
              this.sendsaveUpdateThresholdRules.emit(true);
              this.getThresholdRules();             
            }
          });
    }

  UpdateThresholdRules(){
    var tempQuery = [];
    if (this.rules.length > 0) {
      for (let i = 0; i < this.rules.length; i++) {
        var obj = {
          questionID: this.rules[i].quetionID,
          questionTitle: this.rules[i].questionTitle,   
          weight: this.rules[i].weight,
          position: this.rules[i].position,
          isMandatoryPass: this.rules[i].isMandatoryPass,
          mandatoryRule: this.rules[i].mandatoryRule   
        };
        tempQuery.push(obj);
      }
    }
    var ReqModel = {
      updateReferralQueueQuetion: tempQuery,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      officeID: this.myOfficeID,
    };
    this.loaderService.show();
    this.formsService.updateThresholdRules(ReqModel).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.toastr.success('Record update successfully.', '', {
            timeOut: 3000,
          });
         this.sendsaveUpdateThresholdRules.emit(true);
         this.getThresholdRules();
        } else {        
         this.loaderService.hide();
        }
      } else {        
        this.loaderService.hide();
      }
    });
  }


 dropRule(event: CdkDragDrop<any[]>) {
   moveItemInArray(this.rules, event.previousIndex, event.currentIndex); 
    var record: any = [] = [];
    var reOrdersList: any = [] = [];
    record = this.rules;
    if (record.length > 0) {
      reOrdersList = [];
      for (let i = 0; i < record.length; i++) {
        var obj = {
          quetionID: record[i].quetionID,
          position: i + 1
        }
        reOrdersList.push(obj);
      }

      var reqModel = {
        referralID: this.referralID,
        rules: reOrdersList,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: this.myOfficeID,
        databaseID: Number(this.databaseId)
      }
      this.loaderService.show();
      this.formsService.reorderThresholdRules(reqModel).subscribe((response) => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.getThresholdRules();          
          } else {
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    }
  }

 
}
